import { Button } from "@/components/ui/button";
import { ExternalLink, Receipt } from "lucide-react";
import { BillingDetailsSettings } from "@/components/settings/BillingDetailsSettings";
import { useTestClock } from "@/contexts/TestClockContext";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export function BillingSection() {
  const { openCheckoutInNewTab } = useTestClock();
  const { toast } = useToast();

  const handlePortal = async () => {
    try {
      const { data, error } = await supabase.functions.invoke("customer-portal");
      if (error) throw error;
      if (data?.error) {
        toast({ title: "Error", description: data.message || "Could not open portal", variant: "destructive" });
        return;
      }
      if (data?.url) {
        if (openCheckoutInNewTab) window.open(data.url, "_blank");
        else window.location.href = data.url;
      }
    } catch {
      toast({ title: "Error", description: "Could not open billing portal.", variant: "destructive" });
    }
  };

  return (
    <div className="space-y-5">
      {/* Stripe portal */}
      <div className="rounded-xl border border-border/60 bg-card overflow-hidden">
        <div className="p-5 sm:p-6 flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-start gap-4 min-w-0">
            <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/15 flex items-center justify-center shrink-0">
              <Receipt className="h-5 w-5 text-primary" />
            </div>
            <div className="min-w-0">
              <h3 className="font-semibold">Invoices & payment methods</h3>
              <p className="text-sm text-muted-foreground mt-1 max-w-md">
                View invoices, update payment methods, and download receipts via the secure billing portal.
              </p>
            </div>
          </div>
          <Button onClick={handlePortal} size="sm" className="gap-2 shrink-0 shadow-fluent-2">
            Open portal <ExternalLink className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>

      {/* Company billing details — ships own container */}
      <BillingDetailsSettings />
    </div>
  );
}

